import { TraceXInterceptor } from '@trace-x/trace-x-generator';
// tslint:disable:variable-name
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TariffSearchResultService {

  private _sortBy: string;
  private _sortDirection: 'neutral' | 'asc' | 'desc' = 'neutral';
  private _pageNumber = 1;
  private _pageSize = 10;
  private _hasMoreResults = false;
  private _initialLoading = true;

  constructor() { }

  get sortBy(): string {
    return this._sortBy;
  }

  set sortBy(value: string) {
    this._sortBy = value;
  }

  get pageNumber(): number {
    return this._pageNumber;
  }

  set pageNumber(value: number) {
    this._pageNumber = value;
  }

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
  }

  get hasMoreResults(): boolean {
    return this._hasMoreResults;
  }

  set hasMoreResults(value: boolean) {
    this._hasMoreResults = value;
  }

  get sortDirection(): 'neutral' | 'asc' | 'desc' {
    return this._sortDirection;
  }

  set sortDirection(value: 'neutral' | 'asc' | 'desc') {
    this._sortDirection = value;
  }

  get initialLoading(): boolean {
    return this._initialLoading;
  }

  set initialLoading(value: boolean) {
    this._initialLoading = value;
  }

  /**
   * Sorts the given list of results based on the sortBy and sortDirection properties of the service.
   * @param resultList - The list of results to be sorted.
   * @returns The sorted list of results.
   */
  sortResults(resultList: any[]): any[] {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-search-result.service.ts.TariffSearchResultService.sortResults');
    if (!this.sortBy || this.sortDirection === 'neutral') {
      return resultList;
    }
    return resultList.sort((a, b) => {
      if (this.sortDirection === 'asc') {
        if (typeof a[this.sortBy] === 'number' && typeof b[this.sortBy] === 'number') {
          return a[this.sortBy] - b[this.sortBy];
        } else {
          if (String(a[this.sortBy]) < String(b[this.sortBy])) {
            return -1;
          }
          if (String(a[this.sortBy]) > String(b[this.sortBy])) {
            return 1;
          }
          return 0;
        }
      } else {
        if (typeof a[this.sortBy] === 'number' && typeof b[this.sortBy] === 'number') {
          return b[this.sortBy] - a[this.sortBy];
        } else {
          if (String(a[this.sortBy]) > String(b[this.sortBy])) {
            return -1;
          }
          if (String(a[this.sortBy]) < String(b[this.sortBy])) {
            return 1;
          }
          return 0;
        }
      }
    });
  }

  modifyResultList(resultList: any[]): any[] {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/services/tariff-search-result.service.ts.TariffSearchResultService.modifyResultList');
    // this.pageNumber = this._pageNumber;
    return resultList.map((result) => {
      return {
        ...result,
        selected: false,
      };
    });
  }
}
